import { axios, Response } from '../../index'

const deleteChecklistModel = (checklistId: string): Response<null> => {
  return axios.delete(`/v1/favorites/favorite-checklists/${checklistId}`)
}

export default deleteChecklistModel
